import { render } from "./ServiceAi.vue?vue&type=template&id=596b5786"
import script from "./ServiceAi.vue?vue&type=script&lang=js"
export * from "./ServiceAi.vue?vue&type=script&lang=js"

import "./ServiceAi.vue?vue&type=style&index=0&id=596b5786&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__